export const INFO_CLIENT = {
  titlePage: 'Détail groupe',
  titlePageEnseigne: 'Détail de l’enseigne',
  titlePagePDV: 'Détail du point de vente',
  btnModifier: 'Modifier le client',
  btnCopieLien: 'Copier le lien',
  btnOuvrirLien: 'Ouvrir',
};

export const DETAIL_CLIENT = {
  informations: {
    adresse: 'Adresse',
    marques: 'Marques',
    telephone: 'Téléphone',
    email: 'Email',
    groupe: 'Groupe :',
    enseigne:'Enseigne :',
    secteurActivite: 'Secteur d’activité',
    societe: 'Société',
    applicationTva: 'Application TVA',
    siren: 'Siren',
    referenceHavas: 'Référence Havas'
  },
  ongletEnseiqgnepDV: {
    titleOnglet: 'Enseignes et Points de vente',
    titleOngletEnseigne: 'Points de vente',
    btnAjoutPDV: 'Ajouter un point de vente',
    table: {
      colonneClient: 'Client',
      colonneType: 'Type',
      colonneAdresse: 'Adresse',
      colonneTelephone: 'Téléphone',
      colonneEmail: 'Email',
      colonneAction: 'Action',
    },
    typeClient: {
      enseigne: 'Enseigne',
      pointVente: 'Point de vente',
    },
  },
  ongletBudget: {
    titleOnglet: 'Budget',
    btnCreerExercice: 'Créer un exercice',
    btnExport: 'Exporter',
    budgetDepense: 'Budget dépensé',
    soldeRestant: 'Solde restant',
    libelleBudgetEncours: 'Budget 2020',
    table: {
      colonnePDV: 'Point de vente',
      colonneType: 'Type',
      colonneAdresse: 'Adresse',
      colonneRegie: 'Régie',
      colonneFormat: 'Format',
      colonneCategorie: 'Catégorie',
      colonnesDates: 'Dates',
      colonneDuree: 'Durée',
      colonneBudgetNet: 'Budget Net',
      colonneTlpe: 'TLPE',
      colonneHonoraires: 'Honoraires',
      colonneFT: 'Frais techniques',
      colonneTotal: 'Total',
    }
  },
  ongletRecom: {
    titleOnglet: 'Recommandations',
    btnCreerRecom: 'Créer une recommandation',
    table: {
      colonneNumRecom: 'N° recommandation',
      colonneDate: 'Date de création',
      colonneCommercial: 'Commercial',
      colonneBudgetNet: 'Budget Net',
      colonneTlpe: 'TLPE',
      colonneHonoraires: 'Honoraires',
      colonneFT: 'Frais techniques',
      colonneTotal: 'Total',
      colonneAction: 'Action',
    }
  },
  ongletContacts: {
    titleOnglet: 'Contacts',
    btnAjoutContact: 'Ajouter un contact',
    aucunResultat: 'Aucun résultat trouvé'
  },
  ongletCartographie: {
    titleOnglet: 'Cartographie',
    btnDetail: 'Plus de détails',
  },
  ongletPJ: {
    titleOnglet: 'Pièces jointe',
    btnAjoutPJ: 'Ajouter une pièce jointe',
    aucunPJ: 'Aucune pièce jointe',
  },
};

export const LISTE_RECOM_CLIENT = {
  actionGroupe: {
    titre: 'Actions groupées',
    afficherPortail: 'Afficher dans le portail',
    masquerPortail: 'Masquer dans le portail'
  },
  btnAppliquer: 'Appliquer',
  btnExporterRecom: 'Exporter',
  column: {
    dateCreation: 'Date de création',
    commercial: 'Commercial',
    nomRecom: 'Recommandation',
    prixNet: 'Net facturé',
    tlpe: 'TLPE',
    honoraires: 'Honoraires',
    fraisTechinique: 'Frais technique',
    montant: 'Total',
    action: 'Action',
    portail: 'Portail'
  },
  ensembleMontant: 'Voir l’ensemble des montants'
}
